var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workspace"},[_c('tabs',{staticClass:"w-term-tabs",on:{"addNewSess":function($event){return _vm.$emit('addNewSess')}}}),_c('sessions',{on:{"close":_vm.focusCurTerm}}),_c('ssh-known-hosts'),_c('keys')],1)}
var staticRenderFns = []

export { render, staticRenderFns }